import styled from 'styled-components';

export const Label = styled.label`
	position: relative;
	padding-left: 4.2rem;
	display: flex;
	font-size: 1.8rem;
	font-weight: ${({ theme }) => theme.font.light};
	color: ${({ theme }) => theme.form.color.primary};
	line-height: 2.1;
`;

export const Circle = styled.span`
	cursor: pointer;
	position: absolute;
	top: 50%;
	left: 0;
	transform: translateY(-50%);
	display: block;
	width: 1.8rem;
	height: 1.8rem;
	border-radius: 50%;
	border: 1px solid ${({ theme }) => theme.form.color.highlight};

	&:after {
		display: none;
		content: '';
		width: 1rem;
		height: 1rem;
		border-radius: 50%;
		position: absolute;
		top: 0.3rem;
		left: 0.3rem;
		background: ${({ theme }) => theme.form.color.highlight};
	}
`;

export const Input = styled.input`
	position: absolute;
	visibility: hidden;

	&:checked + ${Circle} {
		&:after {
			display: block;
		}
	}
`;
